import { Sensor } from '@thingslog/repositories';
import GenericDigitalSensor from '@thingslog/repositories/src/sensor/GenericDigitalSensor';
import GenericAnalogSensor from '@thingslog/repositories/src/sensor/GenericAnalogSensor';
import OnOffSensor from '@thingslog/repositories/src/sensor/OnOffSensor';
import { SensorUtils } from '@thingslog/utils';

export class SensorsUtil {
  public static getSensorUnits = (sensor: Sensor): string => {
    return SensorUtils({ sensor }).getSensorUnit();
  };

  public static getFlowUnitDirectly = (sensor: Sensor): string | null => {
    return SensorUtils({ sensor }).getFlowUnitDirectly();
  };

  public static getDefaultUnit = (sensor: Sensor): string => {
    return SensorUtils({ sensor }).getDefaultUnit();
  };

  public static isGenericDigitalSensor = (sensor: Sensor): sensor is GenericDigitalSensor => {
    return SensorUtils({ sensor }).isDigitalSensor();
  };

  public static isGenericAnalogSensor = (sensor: Sensor): sensor is GenericAnalogSensor => {
    return SensorUtils({ sensor }).isAnalogSensor();
  };

  public static isOnOffSensor = (sensor: Sensor): sensor is OnOffSensor => {
    return SensorUtils({ sensor }).isOnOffSensor();
  };
}
